import { useState } from "react";
import { DialogTrigger } from "react-aria-components";
import { Controller, useForm } from "react-hook-form";

import { AlertModal } from "@/components/generic/AlertModal";
import { Button } from "@/components/generic/Button";
import { Checkbox } from "@/components/generic/Checkbox";
import { TrialCTAModal } from "@/components/trial/TrialCTAModal";
import { useLocalStorageFlag } from "@/hooks/use-local-storage-flag";
import { trialText } from "@/hooks/use-trial-period";

interface PurchaseLiveNumberDialogProps {
  isTrialPeriod: boolean;
  onPurchase: () => void;
  buttonText?: string;
  buttonClassName?: string;
  buttonSize?: "sm" | "lg";
  buttonIntent?: "primary" | "secondary";
}

interface FormValues {
  noShow: boolean;
}

export function PurchaseLiveNumberDialog({
  isTrialPeriod,
  onPurchase,
  buttonText = "Vis",
  buttonClassName = "border-theme-on-glass-variant/70! inline-flex !h-6 !min-w-0 cursor-pointer items-center gap-x-2 p-4 py-0 text-xs font-medium text-nowrap text-theme-on-background",
  buttonSize = "sm",
  buttonIntent = "secondary",
}: PurchaseLiveNumberDialogProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { isExist, setItem } = useLocalStorageFlag({
    key: "suppressPurchaseLiveNumberConfirmation",
  });

  const { control, getValues } = useForm<FormValues>({
    defaultValues: { noShow: false },
  });

  const handleOpenChange = (open: boolean) => {
    if (open && isExist) {
      onPurchase();
      return;
    }
    setIsOpen(open);
  };

  return (
    <DialogTrigger onOpenChange={handleOpenChange} isOpen={isOpen}>
      <Button
        size={buttonSize}
        intent={buttonIntent}
        animate
        className={buttonClassName}
      >
        {buttonText}
      </Button>

      {isTrialPeriod ? (
        <TrialCTAModal title={trialText} />
      ) : (
        <AlertModal
          isOpen={isOpen}
          iconDisable={true}
          title="Bekræft køb af Live numre"
          onClose={() => setIsOpen(false)}
          onConfirm={() => {
            onPurchase();

            if (getValues("noShow")) {
              setItem();
            }
          }}
          description="Live numre for denne virksomhed koster 1 credit. Bekræft, at du vil købe det."
          confirmation={
            <Controller
              name="noShow"
              control={control}
              render={({ field }) => (
                <Checkbox
                  boxClassName="border-theme-outline-variant"
                  className="text-theme-on-glass-variant"
                  isSelected={field.value}
                  value="noShow"
                  onChange={field.onChange}
                >
                  Vis ikke igen
                </Checkbox>
              )}
            />
          }
        />
      )}
    </DialogTrigger>
  );
}
